import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Tests became Analytics. Old links (bookmarks, chat messages, the external
 * order emails) keep working: each old path maps to where that page lives now.
 */
export const Route = createFileRoute("/tests/$")({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      href: analyticsPathFor(params._splat ?? "", search),
      replace: true,
    });
  },
});

function analyticsPathFor(splat: string, search: Record<string, unknown>): string {
  const path = splat.replace(/^\/+|\/+$/g, "");
  const order = path.match(/^requests\/orders\/(\d+)$/);
  if (order) return `/analytics/external/orders/${order[1]}`;
  const imp = path.match(/^requests\/imports\/(\d+)$/);
  if (imp) return `/analytics/external/imports/${imp[1]}`;
  if (path === "requests") {
    return search.mode === "external" ? "/analytics/external" : "/analytics";
  }
  if (path === "catalogue" || path === "labs" || path.startsWith("templates")) {
    return `/analytics/${path}`;
  }
  return "/analytics";
}
